/**
 * Color Palette Configuration
 * Primary and Secondary color palettes for Daily Dynamic Trading Co.
 */

export const colors = {
  brand: {
    50: '#e8f4ff',
    100: '#bae0ff',
    200: '#8cccff',
    300: '#5eb8ff',
    400: '#30a4ff',
    500: '#1E90FF', // Base color (Dodger Blue)
    600: '#1873cc',
    700: '#125699',
    800: '#0c3966',
    900: '#061c33',
  },
  secondary: {
    50: '#fff4e8',
    100: '#ffe0b8',
    200: '#ffcc88',
    300: '#ffb858',
    400: '#ffa428',
    500: '#FF8D1E', // Secondary color (Orange)
    600: '#cc7118',
    700: '#995512',
    800: '#66380c',
    900: '#331c06',
  },
};

// Color tokens for easy access
export const colorTokens = {
  primary: {
    main: colors.brand[500],
    light: colors.brand[300],
    dark: colors.brand[700],
  },
  secondary: {
    main: colors.secondary[500],
    light: colors.secondary[300],
    dark: colors.secondary[700],
  },
};

// Export individual color values for convenience
export const primaryColor = colors.brand[500];
export const secondaryColor = colors.secondary[500];

